var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Background"},[_c('h2',{staticClass:"Title"},[_vm._v(" 소셜 업로드 ")]),_c('v-btn',{on:{"click":_vm.testBtn}},[_vm._v("test버튼")]),_c('v-btn',{on:{"click":_vm.uploadBtn}},[_vm._v("업로드버튼")]),_c('SocialUpload')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }